var format_output = text => {
  text = text.replace(/\s\./g, '.').trim();
  text = text.replace(/\sn't/g, "n't");
  text = text.replace(/\s"\s/g, ' "');
  return text;
};
export default format_output;

// Why can't we all get "along"?
